import { Star } from "lucide-react";

export const Stars = ({ rating, size = 16 }) => (
  <span className="inline-flex items-center gap-0.5" aria-label={`${rating} out of 5 stars`}>
    {[1, 2, 3, 4, 5].map((i) => (
      <Star
        key={i}
        style={{ width: size, height: size }}
        className={i <= Math.round(rating) ? "fill-[#F59E0B] text-[#F59E0B]" : "fill-slate-200 text-slate-200"}
      />
    ))}
  </span>
);
